<template>
  <v-card
      :max-width="$vuetify.breakpoint.smAndUp ? '450px' : 'auto'"
  >
  <v-card>
    <v-card v-if="!loading && show">
        <v-card-title
            class="heading grey lighten-2"
        >
          <v-row
              align="center"
              class="ma-0"
          >
            <v-icon>mdi-star-outline</v-icon>
            <span class="text--secondary text--darken-1 mx-1">Avalie o processamento</span>
            <v-spacer/>
            <v-btn
                icon
                depressed
                color="error"
                @click="onCloseClick"
                :disabled="isUpdating"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-row>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-row
              class="ma-0 my-1"
          >
            <span class="body-1 ma-2"><b>Seu processamento atingiu o resultado esperado? </b></span>
          </v-row>
          <v-row
              align="center"
              justify="center"
              class="ma-0"
          >
            <star-rating v-bind:star-size="30" @rating-selected="updateRating" :rating="rating" />
          </v-row>
          <v-row justify="center">
            <span class="ma-0 body-1">{{rateOptions[rating-1]}}</span>
          </v-row>
        </v-card-text>
        <v-text-field
          label="Comentario"
          placeholder="Comentário opcional"
          v-model="comment"
          outlined
          class="comment"
          hide-details/>
        <span v-if="showAlert" class="body-1 ma-2"><b>Você deve selecionar uma nota para poder enviar.</b></span>
        <v-card-actions class="pa-4 justify-center">
          <v-btn
              color="accent"
              @click="onSaveClick"
              :disabled="!canSend"
              :loading="isUpdating">
            <span>Enviar</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-card>
    <v-card v-if="loading">
        <v-card-title class="heading grey lighten-2">
          <span class="body-1 ma-2"><b>Obrigado por enviar seu feedback!</b></span>
        </v-card-title>
    </v-card>
  </v-card>
</template>

<script>
import {FloatingCardsEventBus} from "../../../../helpers/mapview/events"
import StarRating from 'vue-star-rating'
import {updateProcessingEvaluation} from "@/api/api-project";

export default {
  name: "ProcessingEvaluateCard",
  components: {StarRating},
  data: () => ({
    isUpdating: false,
    loading: false,
    show: false,
    rating: 1,
    id_processing: "",
    comment: "",
    showAlert: false,
    canSend: false,
    rateOptions: ["Não atingiu o resultado esperado", "Atingiu muito pouco do resultado esperado", "Atingiu moderadamente o resultado esperado", "Atingiu boa parte do resultado esperado", "Atingiu completamente o resultado esperado"],
  }),
  methods: {
    onCloseClick() {
      FloatingCardsEventBus.$emit("closeEvaluate")
    },
    onCancelClick() {
      FloatingCardsEventBus.$emit("closeEvaluate")
    },
    onUpdateCard(score, comment, id_processing, show = false) {
      this.show = show
      this.rating = parseInt(score)
      this.id_processing = id_processing
      this.comment = comment
    },
    updateRating(newRating) {
      this.rating = newRating
      this.canSend = true
    },
    onSaveClick() {
      window.rating = this.rating;
      if (this.rating <= 0) {
        this.showAlert = true
        return
      }

      let comment = '';
      if (this.comment !== null && this.comment !== undefined) {
        comment = this.comment
      } else {
        comment = '';
      }

      updateProcessingEvaluation(this.$apiAuth.getAuthToken(), this.id_processing, this.rating, comment)
          .then(() => {
            this.loading = true
            setTimeout(() => {
              FloatingCardsEventBus.$emit("closeEvaluate")
            }, 3000)
          })
    }
  },
  mounted() {
  }
}
</script>

<style scoped lang="scss">
  .comment {
    display: block;
    line-height: 1.2;
    margin: 18px;
    }
</style>
